import { render, staticRenderFns } from "./ExpertSalaries.vue?vue&type=template&id=0f3e8da1&scoped=true&"
import script from "./ExpertSalaries.vue?vue&type=script&lang=js&"
export * from "./ExpertSalaries.vue?vue&type=script&lang=js&"
import style0 from "./ExpertSalaries.vue?vue&type=style&index=0&id=0f3e8da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3e8da1",
  null
  
)

export default component.exports